/**
 * The words of the HR screens review of 2026-10-04 that were still open in pm on 2026-10-07
 * (part B). Kept beside the catalogue, as the other HR rounds' words are, and spread into it.
 */
export const HR_PM_B_EN = {
    // psgb21jm: a WPS file's lines are searched; a GOSI item with no name says so, never its id.
    'gov_sa.mudad.files.lines.search': 'Find by name, employee number, identity number or IBAN',
    'gov_sa.mudad.files.lines.none_found': 'No line matches',
    'gov_sa.gosi.submissions.no_name': 'No name on the register',
    // psgb3t0w: the figures above the compliance list say their period.
    'gov_sa.mudad.compliance.col.latest': 'Latest month',
    'gov_sa.mudad.compliance.stat.latest_month': 'In the latest month',
    'gov_sa.mudad.compliance.stat.all_months': 'Since the first file',
};
export const HR_PM_B_AR = {
    'gov_sa.mudad.files.lines.search': 'ابحث بالاسم أو الرقم الوظيفي أو رقم الهوية أو الآيبان',
    'gov_sa.mudad.files.lines.none_found': 'لا سطر يطابق البحث',
    'gov_sa.gosi.submissions.no_name': 'بلا اسم في السجل',
    'gov_sa.mudad.compliance.col.latest': 'آخر شهر',
    'gov_sa.mudad.compliance.stat.latest_month': 'في آخر شهر',
    'gov_sa.mudad.compliance.stat.all_months': 'منذ أول ملف',
};
//# sourceMappingURL=i18n-hr-pm-b.js.map